/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/23/19
 * Time: 10:07 AM
 */
import React, {Component} from 'react';
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Col, Row} from "reactstrap";
import './Style.css'
import {Button, Form} from "semantic-ui-react";
import LabelInput from "../../../../../components/Input/Input/TxtLbl";
import Cookies from "js-cookie";
import axiosTags from "../../../../../axios/axios_tag";
import * as common from "../../../../../const/Common/CommonFunc";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import '../../../../../commonBtnStyle.css'
import apiConfig from "../../../../../axios/axios_api_services";

class App extends Component {
  state = {
    name: "",
  };
  toggle = () => {
  };

  handleChange = name => event => {
    let value = event.target.value;
    this.setState({
      [name]: value
    });
  };

  fillData = () => {
    let data = this.props.data;
    this.setState({
      name: data.name
    })
  };
  isValidate = () => {
    if (this.state.name.trim() === "") {
      common.notifyMessage("Please enter department name");
    } else {
      let data = this.props.data;
      const obj = {
        "departmentId": data.departmentId,
        "name": this.state.name.trim()
      };
      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };

      swal({
        title: "Do you want to update department details?",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Yes",
            value: "action",
            className: "okay-btn"
          }
        },
      })
        .then((value) => {
          switch (value) {

            case "action":
              this.props.spinnerHandler(true);
              axiosTags.post(apiConfig.CORPORATES_DEPARTMENT, obj, {headers: headers})
                .then(response => {
                  if (response.data.success) {
                    common.warningAlert("Department details successfully updated - (" + this.state.name.trim() + ")", 0);
                    this.props.closeModal();
                    this.props.refreshData();
                  } else {
                    common.warningAlert(response.data.message, 1)
                  }
                })
                .catch(async error => {
                  let result = await common.checkErrorResponse(error);
                  if (result === 1) {
                    this.isValidate()
                  }
                })
                .finally(fin => {
                  this.props.spinnerHandler(false);
                });
              break;
            default:
          }
        });
    }
  };

  componentDidMount() {
    this.fillData();
  }

  render() {
    return (
      <div>
        <MDBModal isOpen={true} toggle={this.toggle} size="md">
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>
            Update Department Details
          </MDBModalHeader>
          <MDBModalBody>
            <Row style={{padding: '10px'}}>
              <Col lg={12}>
                <Form>
                  <Form.Group widths='equal'>
                    <LabelInput
                      required
                      tagText={"Department Name"}
                      placeholder={"Department Name"}
                      value={this.state.name}
                      onChange={this.handleChange('name')}
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                <Button className="px-5" onClick={this.isValidate}>Update Department Details</Button>
              </Col>
            </Row>
          </MDBModalBody>
        </MDBModal>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  table_data: state.COPAdminReducer.departmentTable_data,
  departmentData: state.COPAdminReducer.departmentData,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addDepartment: (data) => dispatch(actionCreator.addDepartment(data)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
